window.dataLayer = window.dataLayer || [];

function gtag() {
  dataLayer.push(arguments);
}

export class DefaultLayout {

  _footerComponent;
  _cookiesComponent;

  constructor(
    _footerComponent
  ) {
    this._footerComponent = _footerComponent;
  }

  init() {
    this._cookiesComponent = document.querySelector('app-cookies');

    this.setGtag(false, 'default');
    this.cookiesComponentActions();
  }

  cookiesComponentActions() {
    if (this._cookiesComponent) {
      const analyticsCookie = (analyticsCookie) => {
        if (analyticsCookie) {
          var _linkedin_partner_id = "4351033";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);

          (function (l) {
            if (!l) {
              window.lintrk = function (a, b) {
                window.lintrk.q.push([a, b])
              };
              window.lintrk.q = []
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'
            s.parentNode.insertBefore(b, s);
          })(window.lintrk);
        }

        this.setGtag(analyticsCookie, 'update');
      };

      const functionalCookie = (functionalCookie) => {
        if (functionalCookie) {
          this._footerComponent.loadMap();
        }
      };

      const cookiesActions = (cookiesPreferences) => {
        analyticsCookie(cookiesPreferences.analyticsCookie);
        functionalCookie(cookiesPreferences.functionalCookie);
      };

      window['areCookiesPreferencesSet'] = this._cookiesComponent.areCookiesPreferencesSet;
      window['cookiesPreferences'] = this._cookiesComponent.cookiesPreferences;

      if (this._cookiesComponent.areCookiesPreferencesSet) {
        cookiesActions(this._cookiesComponent.cookiesPreferences);
      }

      this._cookiesComponent.addEventListener('cookiesBuilt', () => location.reload());
    }
  }

  setGtag(statistics, type) {
    gtag('consent', type, {
      'analytics_storage': statistics ? 'granted' : 'denied',
      'ad_storage': statistics ? 'granted' : 'denied'
    });
  }
}
